import React from 'react';
import { ArrowRightLeft, Check, FileText, Link2, UserRound } from 'lucide-react';
const navItems = ['Control Center', 'Case Management', 'Programs', 'Citizen Directory', 'Activity Log'];
const linkedRecords = [{
  icon: UserRound,
  label: 'Citizen record',
  value: 'Lina Ortiz · North Region'
}, {
  icon: FileText,
  label: 'Application',
  value: 'APP-311 · Adult training grant'
}, {
  icon: Link2,
  label: 'Program rule',
  value: 'Transport support · version 3'
}];
const progress = ['Request', 'Information check', 'Assigned team', 'Coordinated support', 'Recorded decision', 'Progress review'];
const completed = 3;
const annotations = [{
  title: 'Connected information',
  body: 'Related records, applications and rules appear together, each linked to its source.'
}, {
  title: 'Tools for taking action',
  body: 'The next steps this person is responsible for sit beside the information they need.'
}, {
  title: 'Progress tracking',
  body: 'Everyone involved can see where the work stands and what comes next.'
}];

/** Large annotated preview of a Noetivra workspace, built from fictional records. */
export function WorkspacePreview() {
  return <figure data-id="element-1236" data-mp="1344auccyotcf">
      <div className="rounded-xl border border-line bg-white shadow-premium overflow-hidden" data-id="element-1237" data-mp="134clrypixokz">
        <div className="flex items-center justify-between gap-4 border-b border-line bg-surface-bg px-4 sm:px-5 py-3" data-id="element-1238" data-mp="1gzf3dj3qh2dm">
          <p className="font-heading font-bold text-sm text-ink-dark" data-id="element-1239" data-mp="ocubmhjcio9j">
            Noetivra <span className="font-medium text-ink-muted" data-id="element-1240" data-mp="oarap2gnnaq1">· Administration Control Panel</span>
          </p>
          <span className="hidden sm:inline text-xs font-medium text-ink-muted" data-id="element-1241" data-mp="y2x147r9dk34">Fictional records</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[200px_1fr]" data-id="element-1242" data-mp="tbot9g5ku6s2">
          <nav aria-label="Preview navigation" className="hidden lg:block border-r border-line p-4" data-id="element-1243" data-mp="tadpvhg1n11h">
            <ul className="space-y-1" data-id="element-1244" data-mp="5k9nteii79cl">
              {navItems.map(item => <li key={item} className={`rounded-md px-3 py-2 text-sm ${item === 'Case Management' ? 'bg-surface-muted font-semibold text-navy' : 'text-ink-muted'}`} data-id="element-1245" data-mp="n9ij5thaamj">
                  {item}
                </li>)}
            </ul>
          </nav>

          <div className="p-4 sm:p-6 lg:p-8" data-id="element-1246" data-mp="2feygk1ok84hh">
            <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-1247" data-mp="2fgrm1dnfsinw">
              <div data-id="element-1248" data-mp="1hshl71ze00yd">
                <p className="text-xs font-medium text-ink-muted" data-id="element-1249" data-mp="1ht152o8lkzf1">REQ-1042</p>
                <p className="font-heading font-bold text-xl text-ink-dark" data-id="element-1250" data-mp="1mqjbo7z572jv">Training place support</p>
              </div>
              <span className="rounded-md border border-navy/20 bg-surface-muted px-2.5 py-1 text-xs font-semibold text-navy" data-id="element-1251" data-mp="1rr6zylvzl5ae">
                In review
              </span>
            </div>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-5 gap-5" data-id="element-1252" data-mp="336c7q4az5u0v">
              <div className="relative md:col-span-3 rounded-lg border border-line p-5" data-id="element-1253" data-mp="374jm4shyuj8w">
                <Marker n={1} data-id="element-1254" data-mp="vhg67ogw22ks" />
                <p className="text-sm font-semibold text-ink-dark mb-3" data-id="element-1255" data-mp="vklvp4tfj6h1">Linked information</p>
                <ul className="divide-y divide-line" data-id="element-1256" data-mp="rhpi5siqy0jy">
                  {linkedRecords.map(({
                  icon: Icon,
                  label,
                  value
                }) => <li key={label} className="flex items-start gap-3 py-2.5" data-id="element-1257" data-mp="hr4bdhsx5ppy">
                      <Icon size={16} className="mt-0.5 shrink-0 text-teal" aria-hidden="true" data-id="element-1258" data-mp="hp0a77men4td" />
                      <span className="min-w-0" data-id="element-1259" data-mp="cpx55n6fcyle">
                        <span className="block text-xs text-ink-muted" data-id="element-1260" data-mp="7sng48my6oy3">{label}</span>
                        <span className="block text-sm font-medium text-ink-dark" data-id="element-1261" data-mp="3qtjcbfvi537">{value}</span>
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="relative md:col-span-2 rounded-lg border border-line p-5" data-id="element-1262" data-mp="1y5meyagravv5">
                <Marker n={2} data-id="element-1263" data-mp="1t5qaka45d2f2" />
                <p className="text-sm font-semibold text-ink-dark mb-3" data-id="element-1264" data-mp="1t7kubl3omohk">Next steps</p>
                <div className="space-y-2" data-id="element-1265" data-mp="pwf5drtx9d9k">
                  <span className="flex items-center justify-center gap-2 rounded-md bg-navy px-3 py-2 text-sm font-semibold text-white" data-id="element-1266" data-mp="pt9jelglari2">
                    <ArrowRightLeft size={14} aria-hidden="true" data-id="element-1267" data-mp="gv7bdlyfuyla" />
                    Coordinate referral
                  </span>
                  <span className="flex items-center justify-center rounded-md border border-line px-3 py-2 text-sm font-semibold text-navy" data-id="element-1268" data-mp="ls7epp3wln8p">
                    Request more information
                  </span>
                  <span className="flex items-center justify-center rounded-md border border-line px-3 py-2 text-sm font-semibold text-navy" data-id="element-1269" data-mp="bwvy118xq5yb">
                    Record decision
                  </span>
                </div>
              </div>
            </div>

            <div className="relative mt-5 rounded-lg border border-line p-5" data-id="element-1270" data-mp="3kb4ljuwlo6jm">
              <Marker n={3} data-id="element-1271" data-mp="3pa7ptd4ra8qj" />
              <p className="text-sm font-semibold text-ink-dark mb-4" data-id="element-1272" data-mp="3p9fv04izgf1b">Progress</p>
              <ol className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-1273" data-mp="35o5y0b0v5wa6">
                {progress.map((step, index) => {
                const done = index < completed;
                const current = index === completed;
                return <li key={step} className="flex items-center gap-2 text-sm" data-id="element-1274" data-mp="3fkiqj5koa43c" data-mpi={index}>
                      <span className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold ${done ? 'bg-teal text-white' : current ? 'border-2 border-navy text-navy' : 'border border-line text-ink-muted'}`} data-id="element-1275" data-mp="3apv8npk6c7xq">
                        {done ? <Check size={12} aria-hidden="true" data-id="element-1276" data-mp="b9gdxwv2eiuu" /> : index + 1}
                      </span>
                      <span className={done || current ? 'text-ink-dark' : 'text-ink-muted'} data-id="element-1277" data-mp="78msda53hg54">{step}</span>
                    </li>;
              })}
              </ol>
            </div>
          </div>
        </div>
      </div>

      <figcaption data-id="element-1278" data-mp="o8fx6s48avhm">
        <ol className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10" data-id="element-1279" data-mp="o7wbd0bgjmyb">
          {annotations.map((annotation, index) => <li key={annotation.title} data-id="element-1280" data-mp="szxu9534sbxb" data-mpi={index}>
              <p className="flex items-center gap-3 font-heading font-bold text-lg text-ink-dark" data-id="element-1281" data-mp="x0rla7bve6uf">
                <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-teal text-sm font-semibold text-white" data-id="element-1282" data-mp="11zufsxu84uo5">
                  {index + 1}
                </span>
                {annotation.title}
              </p>
              <p className="mt-2 text-ink-muted leading-relaxed" data-id="element-1283" data-mp="1bwpdxfml4t1w">{annotation.body}</p>
            </li>)}
        </ol>
      </figcaption>
    </figure>;
}
function Marker({
  n
}: {
  n: number;
}) {
  return <span aria-hidden="true" className="absolute -top-3 -right-3 inline-flex h-7 w-7 items-center justify-center rounded-full bg-teal text-sm font-semibold text-white ring-4 ring-white" data-id="element-1284" data-mp="3dpwyp4kyw2v6">
      {n}
    </span>;
}